import { render, staticRenderFns } from "./LayoutWrapper.vue?vue&type=template&id=405f765c&"
import script from "./LayoutWrapper.vue?vue&type=script&lang=js&"
export * from "./LayoutWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports